module.exports = {"370211001":"黄岛街道","370211002":"辛安街道","370211003":"薛家岛街道","370211004":"灵珠山街道","370211005":"长江路街道","370211006":"红石崖街道","370211007":"灵山卫街道","370211009":"珠海街道","370211010":"隐珠街道","370211011":"铁山街道","370211012":"滨海街道","370211013":"胶南街道","370211100":"王台镇","370211101":"张家楼镇","370211102":"琅琊镇","370211103":"泊里镇","370211104":"大场镇","370211105":"大村镇","370211106":"六汪镇","370211107":"海青镇","370211108":"宝山镇","370211109":"藏南镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370211.json
// module id = 1262
// module chunks = 0